<template>
  <div :class="['elevation-5', $root.isRTL ? 'notificationRTL' : 'notification']" v-if="$root.notification.isShow" @click="selectActivity($root.notification.activityId)">
    <v-layout row wrap>
      <v-flex xs3>
        <v-icon>email</v-icon>
      </v-flex>
      <v-flex xs9 style="padding: 10px 5px 10px 0px;">
        <v-layout row wrap>
          <v-flex xs12>
            <span style="font-weight: bold;" class="musketeerFont">{{$root.notification.info}} by {{ $root.notification.from }}</span>
          </v-flex>
        </v-layout>
        <v-layout row wrap>
          <v-flex xs12>
            <span class="musketeerFont">Event: {{ $root.notification.event }}</span>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
  </div>
</template>
<script>
  export default {
    name: 'notification',
    data() {
      return {
        mobileNumber: '',
      }
    },
    beforeCreate() {
      this.$Log("Vue [notification] is before create ...");
    },
    created() {
      this.$Log("Vue [notification] is created ...");
    },
    ready() {
      this.$Log("Vue [notification] is ready ...");
    },
    mounted() {
      this.$Log("Vue [notification] is mounted ...");
    },
    updated() {
      this.$Log("Vue [notification] is updated ...");
      var vm = this;
      if (vm.$root.notification.isShow) {
        setTimeout(function () {
          vm.$root.notification = { isShow: false, activityId: null, info: '', from: '', event: '' }
        }, 5000);
      }
    },
    computed: {
    },
    methods: {
      selectActivity(activityId) {
        if (activityId != null) {
          var vm = this;

          vm.$root.dialogPublicMessage = false;
          vm.$root.dialogUsersSettings = false;
          vm.$root.dialogEmergencySettings = false;
          vm.$root.dialogAcountsSettings = false;
          vm.$root.dialogAcountSettings = false;
          vm.$root.activeSubMenu = false;

          var inviteId = '';
          for (var i = 0; i < vm.$root.activities.length; i++) {
            if (vm.$root.activities[i].id == activityId) {
              inviteId = vm.$root.activities[i].activityInviteId;
              break;
            }
          }
          vm.$JoinActivity(inviteId, function (joinResult) {
            vm.$Log("$JoinActivity result >>> " + JSON.stringify(joinResult));
            vm.$SelectActivity(vm, activityId);
          });
        }

        this.$root.notification = { isShow: false, from: '', event: '' };
      },
    }
  }

</script>
<style scoped>

  .notification {
    z-index: 190900 !important;
    position: fixed;
    top: 100px;
    right: 70px;
    background-color: #ffffff;
    border-radius: 5px;
    font-size: 20px;
    z-index: 1000;
    cursor: pointer;
    width: 250px;
    height: 60px;
  }

  .notification i {
    color: #02589B;
    font-size: 35px;
    padding-top: 13px;
  }

  .notification span {
    display: block;
    text-align: left;
    color: #777;
    font-size: 13px;
    float: left;
    width: 180px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .notificationRTL {
    z-index: 190900 !important;
    position: fixed;
    top: 100px;
    left: 70px;
    background-color: #ffffff;
    border-radius: 5px;
    font-size: 20px;
    z-index: 1000;
    cursor: pointer;
    width: 250px;
    height: 60px;
  }

  .notificationRTL i {
    color: #02589B;
    font-size: 35px;
    padding-top: 13px;
  }

  .notificationRTL span {
    display: block;
    text-align: right;
    color: #777;
    font-size: 13px;
    float: right;
    width: 180px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  
</style>


// WEBPACK FOOTER //
// Notification.vue?72aeed5f